// choices.js fires a native `addItem` CustomEvent when an option is picked
// (the Select2 `select2:select` equivalent). Delegated through document so it
// keeps working across the impersonation widgets re-rendering. Under jQuery the
// CustomEvent payload lives on originalEvent.detail.
$(document).on("addItem", ".getAlluserDetails", function (e) {
    var detail = (e.originalEvent || e).detail || {};
    if (detail.value === 'superadmin') {
        // "Back to Super Admin" revert row — now a real choice (see processResults)
        // instead of the old Select2-results DOM injection.
        changeUserSession([{
            "id": "Super Admin",
            "text": "Back to Super Admin",
            "value": $('#superAdminDetails').val()
        }]);
        return;
    }
    changeUserSession([{value: detail.value, text: detail.label}]);
});

$(document).on("addItem", ".getAllAgency", function (e) {
    var detail = (e.originalEvent || e).detail || {};
    changeAgencySession(detail.value, detail.label);
});

$(document).ready(function () {

    window.ChoicesAjax.init(".getAllAgency", {
        placeholder: "Select agency",
        maximumSelectionLength: 10
    });

    // Pin a "Back to Super Admin" revert row to the top of the switcher so it shows
    // the moment the dropdown opens — before/while/after typing — like the old
    // Select2 build did (it unconditionally injected the row into the results DOM on
    // open). Selecting it is handled by the `addItem` handler above (value === 'superadmin').
    //
    // The switcher renders only for a super-admin / impersonation session
    // (#superAdminDetails = $superAdminLogin is set then). The page can carry more
    // than one #superAdminDetails (statusbar variants), so test ALL of them — pin the
    // revert if ANY copy has a value. Working-user role type ('SuperAdmin' even while
    // impersonating) is NOT a reliable signal here (verified via browser probe).
    var hasSuperAdminSession = $('#superAdminDetails').toArray().some(function (el) {
        return (el.value || '').trim() !== '';
    });

    window.ChoicesAjax.init('.getAlluserDetails', {
        minimumInputLength: 3,
        inputTooShort: 'Please begin typing to load results',
        placeholder: 'Enter Admin or Client or talent name email',
        pinnedChoices: hasSuperAdminSession ? [{ value: 'superadmin', label: 'Back to Super Admin' }] : [],
        ajax: {
            url: "/superadmin/users",
            type: 'POST',
            dataType: "json",
            delay: 250,
            data: function (params) {
                return {
                    searchTerm: params.term
                }
            },
            processResults: function (data) {
                var results = [];

                var adminUsers = {text: "Admin Users", children: []};
                var clientUsers = {text: "Client Users", children: []};
                var talentUsers = {text: "Talent Users", children: []};

                $.each(data, function (index, item) {
                    if (item.user_role_id == 2) {
                        adminUsers.children.push({
                            id: item.id,
                            text: item.agency_contact.contact.company + ' / ' + item.username + ' / ' + item.contact.firstname + ' ' + item.contact.lastname + ' / ' + item.email
                        });
                    } else if (item.user_role_id == 3) {
                        clientUsers.children.push({
                            id: item.id,
                            text: item.agency_contact.contact.company + ' / ' + item.username + ' / ' + item.contact.firstname + ' ' + item.contact.lastname + ' / ' + item.email
                        });
                    } else if (item.user_role_id == 4) {
                        talentUsers.children.push({
                            id: item.id,
                            text: item.agency_contact.contact.company + ' / ' + item.username + ' / ' +
                                ((item.contact.stagefirstname || item.contact.firstname) + ' ' +
                                (item.contact.stagelastname || item.contact.lastname)) + ' / ' + item.email
                        });
                    }
                });

                [adminUsers, clientUsers, talentUsers].forEach(function (group) {
                    if (group.children.length > 0) {
                        results.push(group);
                    }
                });

                return {
                    results: results
                }
            },
            cache: true
        }
    });
});

window.changeUserSession = function changeUserSession(userDetails) {
    $.post("/admin/user/session", {getUser: userDetails})
        .done(function (data) {
            if (data.success == true) {
                window.removeAvatarImageCookies();
                // Cross-agency switch returns the target agency's dashboard URL so
                // we land on the correct subdomain; otherwise stay on the current host.
                if (data.data && data.data.agencyurl) {
                    document.location.href = data.data.agencyurl;
                } else {
                    document.location.href = window.location.origin + '/dashboard';
                }
            } else {
                notify('error', 'Failed!', data.notifymessage);
            }
        }, 'json');
}

function changeAgencyRedirect(url) {
    alert(url);
    var csrf_token = $('meta[name="_token"]').attr('content');
    var Urll = url + "/admin/agency";
    var myKeyVals = {getUser: url};
    $.ajax({
        type: 'POST',
        url: Urll,
        data: JSON.stringify(myKeyVals),
        dataType: "json",
        contentType: 'application/json; charset=utf-8',
        async: true,
        processData: false,
        cache: false,
        headers: {
            'X-Alt-Referer': 'sit.mydomain.com',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers': 'Origin,X-Requested-With, Content-Type,Accept, Authorization, X-Custom-Header',
            'Access-Control-Allow-Credentials': 'true'
        },
        success: function (resultData) {
            alert("Save Complete")
        }
    });
}

function changeAgencySession(agency_id, agency_name) {
    var superAdminID = $("#admin_id").val();
    $.post("/admin/agency/session", {getUser: superAdminID, agency_id: agency_id, agency_name: agency_name})
        .done(function (data) {
            if (data.success == true) {
                document.location.href = data.data.agencyurl;
            } else {
                notify('error', 'Failed!', data.notifymessage);
            }
        }, 'json');
}

